
interface SchemaOrgProps {
  type: 'Person' | 'ProfessionalService' | 'Organization';
  data?: any;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const generateSchema = () => {
    const baseUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    switch (type) {
      case 'Person':
        return {
          "@context": "https://schema.org",
          "@type": "Person",
          "name": "João Paulo Scardelato Severino",
          "jobTitle": "Perito Judicial e Assistente Técnico",
          "description": "Perito Judicial com 13 anos de experiência em perícias de engenharia. Atuação no TJ/SP e TRT-15, especializado em insalubridade, periculosidade, ergonomia e sistemas técnicos.",
          "url": baseUrl,
          "image": "https://static.readdy.ai/image/73dfcd03d9821e3620f8279bf4d61d7d/06f260c3ffab18ce4c6854acfb4ad000.png",
          "telephone": "+5517997346470",
          "email": "peritojpss@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Alameda Sabará, 54",
            "addressLocality": "Bebedouro",
            "addressRegion": "SP",
            "addressCountry": "BR"
          },
          "sameAs": [
            "https://www.linkedin.com/in/joaopauloscardelatoseverino",
            "https://wa.me/5517997346470"
          ],
          "knowsAbout": [
            "Perícia Judicial",
            "Assistência Técnica",
            "Insalubridade",
            "Periculosidade",
            "Ergonomia",
            "Consumo de Energia",
            "Máquinas e Equipamentos",
            "Veículos Automotores",
            "Sistemas de Climatização"
          ],
          "hasCredential": [
            {
              "@type": "EducationalOccupationalCredential",
              "name": "Engenharia Elétrica",
              "educationalLevel": "Graduação",
              "credentialCategory": "degree"
            },
            {
              "@type": "EducationalOccupationalCredential",
              "name": "Engenharia Mecânica",
              "educentialLevel": "Graduação",
              "credentialCategory": "degree"
            }
          ]
        };
        
      case 'ProfessionalService':
        return {
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "name": "Perícias Técnicas João Paulo Scardelato Severino",
          "description": "Serviços de perícia judicial e assistência técnica em engenharia. Especializado em insalubridade, periculosidade, ergonomia, consumo de energia e sistemas técnicos.",
          "url": baseUrl,
          "image": "https://static.readdy.ai/image/73dfcd03d9821e3620f8279bf4d61d7d/06f260c3ffab18ce4c6854acfb4ad000.png",
          "telephone": "+5517997346470",
          "email": "peritojpss@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Alameda Sabará, 54",
            "addressLocality": "Bebedouro",
            "addressRegion": "SP",
            "addressCountry": "BR"
          },
          "serviceType": "Perícia Judicial e Assistência Técnica",
          "areaServed": {
            "@type": "State",
            "name": "São Paulo"
          },
          "serviceArea": [
            {
              "@type": "State",
              "name": "São Paulo"
            }
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Serviços de Perícia",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Perícia em Insalubridade",
                  "description": "Perícias técnicas conforme NR-15 para análise de agentes de risco no ambiente de trabalho"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Perícia em Periculosidade",
                  "description": "Perícias técnicas conforme NR-16 para análise de atividades perigosas"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Avaliação Ergonômica",
                  "description": "Avaliação ergonômica completa dos postos de trabalho e análise de condições de saúde ocupacional"
                }
              }
            ]
          },
          "founder": {
            "@type": "Person",
            "name": "João Paulo Scardelato Severino"
          }
        };
        
      case 'Organization':
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Eng. João Paulo Scardelato Severino",
          "url": baseUrl,
          "logo": "https://static.readdy.ai/image/73dfcd03d9821e3620f8279bf4d61d7d/06f260c3ffab18ce4c6854acfb4ad000.png",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+5517997346470",
            "contactType": "customer service",
            "email": "peritojpss@gmail.com"
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Alameda Sabará, 54",
            "addressLocality": "Bebedouro",
            "addressRegion": "SP",
            "addressCountry": "BR"
          },
          "sameAs": [
            "https://www.linkedin.com/in/joaopauloscardelatoseverino"
          ]
        };
        
      default:
        return null;
    }
  };

  const schema = generateSchema();
  
  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
